var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-success py-2 top-space",attrs:{"id":"HomeHeader"}},[_c('h1',{staticClass:"text-white"},[_vm._v(_vm._s(_vm.benutzer.vorname)+" "+_vm._s(_vm.benutzer.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }